<template>
  <a-spin :spinning="loading">
    <a-card>
      <!--<div class="grid grid-cols-2 gap-4">
          <a-form-item class="flex" label="فقط پرونده های باز ">
              <a-switch default-checked class="mr-2"/>
          </a-form-item>
      </div>-->
      <x-table :model="cols" ref="proposalTbl" class="mt-3">
        <template slot="operator" slot-scope="text,record">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              عملیات
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="$getAccess('request.interview')">
                <a href="javascript:;" @click="showMosahebe(text.record.id)">مشاهده مصاحبه</a>

              </a-menu-item>
              <a-menu-item v-if="$getAccess('request.detail')">
                <a href="javascript:;" @click="showDetails(text.record)">مشاهده اطلاعات</a>
              </a-menu-item>
              <a-menu-item v-if="$getAccess('request.detail')">
                <a href="javascript:;" @click="printDetails(text.record)">چاپ درخواست</a>
              </a-menu-item>
              <a-menu-item v-if="$getAccess('request.create')">
                <a href="javascript:;" @click="showAddMosahebe(text.record.id)">ثبت مصاحبه</a>

              </a-menu-item>
              <a-menu-item v-if="$getAccess('request.employment') && !text.record.employed">
                <a href="javascript:;" @click="showSetEmployeModal(text.record.id)">استخدام</a>
              </a-menu-item>
              <a-menu-item v-if="$getAccess('request.delete')">
                <a href="javascript:;" @click="deleteProposal(text.record.id)">بایگانی درخواست</a>
              </a-menu-item>
              <a-menu-item v-if="$getAccess('personnel.type') && text.record.employed">
                <a href="javascript:;" @click="showUpdateTypeModal(text.record.id)">تغییر نوع کاربری درخواست</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </x-table>
      <a-modal :width="1000" v-model="showMosahebeModal" title="مشاهده مصاحبه ها">
        <div v-if="is_skeleton">
          <ASkeleton/>
        </div>
        <div v-else>
          <div v-if="interview.length == 0">
            <a-card>
              مصاحبه ای ثبت نشده است.
            </a-card>
          </div>
          <div v-else>
            <div v-for="item in interview" v-if="interview">
              <a-card :title="item.caj" class="mt-10">
                <a-descriptions>
                  <a-descriptions-item label="تاریخ مصاحبه">
                    {{ item.interview_at | jdate }}
                  </a-descriptions-item>
                  <a-descriptions-item label="مصاحبه کننده">
                    {{ item.interviewer }}
                  </a-descriptions-item>
                  <a-descriptions-item label="وضعیت">
                    {{ item.sts_str }}
                  </a-descriptions-item>
                  <a-descriptions-item lable="" v-if="$getAccess('request.update.interview')">
                    <a-button icon="edit" @click="openEditInterviewModal(item)"/>
                  </a-descriptions-item>
                </a-descriptions>
                <a-card title="جزییات">
                  <a-list>
                    <a-list-item v-for="element,index in item.result" :key="index" v-if="item.result"
                                 style="direction: rtl">
                      <div class="flex w-full flex-col">
                        <div class="flex justify-between w-full items-center">
                          <h3>{{ title_interview[index] }}</h3>
                          <div>
                            <a-tag color="blue">
                              نمره: {{ element.score }}
                            </a-tag>
                            <a-tag color="green" v-if="element.sts == 1">
                              قبول
                            </a-tag>
                          </div>
                        </div>
                        <a-divider/>
                        <p v-if="element.desc">{{ element.desc }}</p>
                        <p v-else>بدون توضیحات</p>
                      </div>
                    </a-list-item>
                  </a-list>
                </a-card>
              </a-card>
            </div>
          </div>
        </div>

        <template slot="footer">
          <a-button key="back" @click="showMosahebeModal=false">
            بستن
          </a-button>
        </template>

      </a-modal>
      <a-modal force-render :width="990" v-model="showAddMosahebeModal" title="ثبت مصاحبه">
        <template slot="footer">
          <a-button v-if="current < 2" type="primary" @click="savefromMosahebe">
            بعدی
          </a-button>
          <a-button
              v-if="current == 2"
              type="primary"
              @click="savefromMosahebe">
            ثبت اطلاعات
          </a-button>
          <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">
            قبلی
          </a-button>
        </template>
        <div>
          <a-steps :current="current" style="direction:rtl">
            <a-step title="ثبت تاریخ و مصاحبه کننده"/>
            <a-step title="ثبت جزئیات"/>
            <a-step title="ایجاد پرونده"/>
          </a-steps>
          <div class="steps-content">

            <div>

              <a-form :form="fromMosahebe0" v-show="current==0" class="mt-4">
                <p style="font-weight: bold">موضوع بررسی</p>
                <a-card title="مشاغل" :bordered="true" class="mt-3">
                  <div class="grid sm:grid-cols-1 md:grid-cols-2 md:gap-3 lg:grid-cols-2 lg:gap-3">
                    <div>
                      <a-form-item label="تاریخ مصاحبه">
                        <input v-if="!interview_at" class="hidden" autocomplete="off"
                               v-decorator="['note',{ rules:[{ required: true, message: 'تاریخ را وارد نمایید' }] }]"/>
                        <date-picker v-model="interview_at"/>
                      </a-form-item>
                    </div>
                    <a-form-item label="نام مصاحبه کننده">
                      <input class="ant-input" autocomplete="off" :disabled="true"
                             v-decorator="['interviewer',{initialValue: admin,rules: [{ required: true, message: 'نام مصاحبه کننده را وارد نمایید' }]}]"/>
                    </a-form-item>
                  </div>
                </a-card>
              </a-form>

              <a-form :form="fromMosahebe1" v-show="current==1">
                <a-row>
                  <span>موضوع بررسی</span>
                </a-row>
                <a-card title="دانش تخصصی" :bordered="true">

                  <a-form-item label="نمره">
                    <a-input-number v-decorator="['result_1.score',{initialValue: 0}]" :min="0" :max="20"/>
                  </a-form-item>

                  <a-form-item label="توضیحات">
                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_1.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />
                  </a-form-item>

                  <!--<a-form-item label="نتیجه">
                      <a-radio-group v-decorator="['result_1.sts']">
                          <a-radio :value="-1">
                              رد شده
                          </a-radio>
                          <a-radio :value="1">
                              قبول
                          </a-radio>

                      </a-radio-group>
                  </a-form-item>-->

                </a-card>
                <br/>
                <a-card title="تحصیلات مرتبط" :bordered="true">

                  <a-form-item label="نمره">
                    <a-input-number v-decorator="['result_2.score',{initialValue: 0}]" :min="0" :max="20"/>
                  </a-form-item>

                  <a-form-item label="توضیحات">
                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_2.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />
                  </a-form-item>

                  <!-- <a-form-item label="نتیجه">
                       <a-radio-group v-decorator="['result_2.sts']">
                           <a-radio :value="-1">
                               رد شده
                           </a-radio>
                           <a-radio :value="1">
                               قبول
                           </a-radio>

                       </a-radio-group>
                   </a-form-item>-->

                </a-card>
                <br/>
                <a-card title="تجربه کاری مرتبط" :bordered="true">

                  <a-form-item label="نمره">
                    <a-input-number v-decorator="['result_3.score',{initialValue: 0}]" :min="0" :max="20"/>
                  </a-form-item>

                  <a-form-item label="توضیحات">

                                        <textarea
                                            class="ant-input"
                                            placeholder=""
                                            v-decorator="['result_3.desc']"
                                            :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />

                  </a-form-item>

                  <!--  <a-form-item label="نتیجه">
                        <a-radio-group v-decorator="['result_3.sts']">
                            <a-radio :value="-1">
                                رد شده
                            </a-radio>
                            <a-radio :value="1">
                                قبول
                            </a-radio>

                        </a-radio-group>
                    </a-form-item>-->

                </a-card>
                <br/>
                <a-card title="رفتار و شخصیت عمومی" :bordered="true">

                  <a-form-item label="نمره">
                    <a-input-number v-decorator="['result_4.score',{initialValue: 0}]" :min="0" :max="20"/>
                  </a-form-item>

                  <a-form-item label="توضیحات">

                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_4.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />

                  </a-form-item>
                  <!--
                                                      <a-form-item label="نتیجه">
                                                          <a-radio-group v-decorator="['result_4.sts']">
                                                              <a-radio :value="-1">
                                                                  رد شده
                                                              </a-radio>
                                                              <a-radio :value="1">
                                                                  قبول
                                                              </a-radio>

                                                          </a-radio-group>
                                                      </a-form-item>-->

                </a-card>
                <br/>
                <a-card title="ویژگی های اختصاصی شغل" :bordered="true">

                  <a-form-item label="نمره">
                    <a-input-number v-decorator="['result_5.score',{initialValue: 0}]" :min="0" :max="20"/>
                  </a-form-item>

                  <a-form-item label="توضیحات">

                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_5.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />

                  </a-form-item>

                  <!-- <a-form-item label="نتیجه">
                       <a-radio-group v-decorator="['result_5.sts']">
                           <a-radio :value="-1">
                               رد شده
                           </a-radio>
                           <a-radio :value="1">
                               قبول
                           </a-radio>

                       </a-radio-group>
                   </a-form-item>-->

                </a-card>

              </a-form>

              <a-form :form="fromMosahebe2" v-show="current==2">
                <a-form-item label="نتیجه کلی مصاحبه">
                  <a-radio-group
                      v-decorator="['sts',{rules: [{ required: true, message: 'نتیجه مصاحبه را انتخاب نمایید' }]}]">
                    <a-radio :value="-1">
                      رد شده
                    </a-radio>
                    <a-radio :value="1">
                      قبول
                    </a-radio>
                    <a-radio :value="2">
                      الویت دوم
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <!-- <a-alert message="توجه داشته باشید که در صورت قبول انتخاب کردن نتیجه کلی مصاحبه برای فرد مورد نظر کد پرسنلی ایجاد خواهد شد." type="warning" />-->

              </a-form>

            </div>

          </div>

        </div>

      </a-modal>
      <a-modal :width="800" v-model="showInformationModal" title="جزییات درخواست">
        <template slot="footer">
          <a-button key="back" @click="showInformationModal=false">
            بستن
          </a-button>
        </template>

        <div id="printContent">
          <a-card :title="personalInformation.name" :bordered="true">
            <div class="grid grid-cols-3 gap-4">
              <div>نام و نام خانوادگی : {{ personalInformation.name }}</div>
              <div>نام لاتین : {{ personalInformation.name_en }}</div>
              <div>کد ملی : {{ personalInformation.ncode }}</div>
              <div>موبایل : {{ personalInformation.mobile }}</div>
              <div>تاریخ ثبت نام : {{ personalInformation.caj }}</div>
              <div>تاریخ به روز رسانی : {{ personalInformation.uaj }}</div>
              <div>شغل متقاضی : {{ personalInformation.job_title }}</div>
              <div>نام پدر : {{ personalInformation.father_name }}</div>
              <div>تاریخ تولد : {{ personalInformation.birth_date | jdate }}</div>
              <div>جنسیت : {{ personalInformation.gender_str }}</div>
              <div>وضعیت تاهل : {{ personalInformation.marriage_sts_str }}</div>
              <div>تعداد فرزند : {{ personalInformation.count_child }}</div>
              <div>شماره شناسنامه : {{ personalInformation.iden_id }}</div>
              <div>سریال شناسنامه : {{ personalInformation.iden_serial }}</div>
              <div>محل صدور : {{ personalInformation.iden_place }}</div>
              <div>محل تولد : {{ personalInformation.birth_place }}</div>
              <div>وضعیت مسکن : {{ personalInformation.house_sts_str }}</div>
              <div>ایمیل : {{ personalInformation.email }}</div>
              <div>تلفن ثابت : {{ personalInformation.phone }}</div>
              <div>شماره بیمه : {{ personalInformation.insurance_no }}</div>
              <div>تلفن ضروری : {{ personalInformation.phone_emergency }}</div>
              <div>نام فرد مرتبط : {{ personalInformation.phone_emergency_name }}</div>
              <div>نسبت فرد : {{ personalInformation.phone_emergency_related }}</div>
              <div>حقوق درخواستی : {{ personalInformation.requested_salary }}</div>
              <div class="col-span-2">شماره حساب بانک پاسارگاد : {{ personalInformation.pasargad_bank_number }}</div>
              <div class="col-span-3">آدرس : {{ personalInformation.address }}</div>
            </div>
          </a-card>
          <br/>

          <a-card title="اطلاعات خانوادگی" :bordered="true">
            <template v-for="(item,index) in personalDetails['family']">
              <div class="grid grid-cols-3 gap-1">
                <div>نام : {{ item.name }}</div>
                <div>نسبت : {{ item.relation }}</div>
                <div>مقطع : {{ item.edu_level_str }}</div>
                <div> رشته تحصیلی : {{ item.edu_title }}</div>
                <div> شغل : {{ item.job }}</div>
              </div>
              <a-divider/>
            </template>
          </a-card>
          <br/>
          <a-card title="اطلاعات تحصیلی" :bordered="true">
            <template v-for="(item,index) in personalDetails['education']">
              <div class="grid grid-cols-3 gap-4">
                <div>مقطع : {{ item.level_str }}</div>
                <div>دانشگاه : {{ item.university }}</div>
                <div>رشته تحصیلی: {{ item.title }}</div>
                <div>گرایش: {{ item.trend }}</div>
                <div>سال شروع: {{ item.start_at }}</div>
                <div>سال خاتمه: {{ item.end_at }}</div>
              </div>
              <a-divider/>
            </template>
          </a-card>
          <br/>
          <a-card title="سوابق آموزشی" :bordered="true">
            <template v-for="(item,index) in personalDetails['traning']">
              <div class="grid grid-cols-3 gap-4">
                <div>مرکز برگزاری : {{ item.university }}</div>
                <div>عنوان دوره : {{ item.title }}</div>
                <div>سال : {{ item.start_at }}</div>
                <div>امکان ارائه گواهینامه : {{ item.has_certificate_str }}</div>
              </div>
              <a-divider/>
            </template>
          </a-card>
          <br/>
          <a-card title="سوابق کاری" :bordered="true">
            <template v-for="(item,index) in personalDetails['jobs_history']">
              <div class="grid grid-cols-4 gap-4">
                <div>نام سازمان : {{ item.university }}</div>
                <div>عنوان شغل : {{ item.title }}</div>
                <div>سال شروع : {{ item.start_at }}</div>
                <div v-if="item.end_at">سال خاتمه : {{ item.end_at }}</div>
                <div v-else>سال خاتمه : تاکنون</div>
                <!--<div>تاکنون : {{ item.end_at }}</div>-->
                <div class="col-span-2">دلیل خاتمه : {{ item.note }}</div>
              </div>
              <a-divider/>
            </template>
          </a-card>
          <br/>
          <a-card title="سوابق شخصی" :bordered="true">
            <div class="dropbox">
              <a-upload-dragger
                  :disabled="true"
                  :multiple="false"
                  action="http://hr.asco-intl.com:2020/kernel/api/register/upload"
                  :file-list="prsonalFileList"
                  :default-file-list="prsonalFileList"
                  @change="fileUpload"
                  :remove="fileRemove"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox"/>
                </p>
                <p class="ant-upload-text">
                  فایل را درگ کنید یا اینکه کاوش کنید.
                </p>
                <p class="ant-upload-hint">
                  فایلی که بارگذاری می کنید باید زیر ۵ مگابایت باشد.
                </p>
              </a-upload-dragger>
            </div>
          </a-card>
        </div>
      </a-modal>
      <a-modal force-render :width="990" v-model="editInterviewModel" title="ویرایش مصاحبه">
        <template slot="footer">
          <a-button type="primary" @click="editInterview">
            ثبت اطلاعات
          </a-button>
        </template>
        <div>
          <div class="steps-content">

            <a-form :form="fromMosahebe">

              <p style="font-weight: bold">موضوع بررسی</p>
              <a-card title="مشاغل" :bordered="true" class="mt-3">
                <div class="grid sm:grid-cols-1 md:grid-cols-2 md:gap-3 lg:grid-cols-2 lg:gap-3">
                  <div>
                    <a-form-item label="تاریخ مصاحبه">
                      <input v-if="!interview_at" class="hidden" autocomplete="off"
                             v-decorator="['note',{ rules:[{ required: true, message: 'تاریخ را وارد نمایید' }] }]"/>
                      <date-picker v-model="interview_at"/>
                    </a-form-item>
                  </div>
                  <a-form-item label="نام مصاحبه کننده">
                    <input class="ant-input" autocomplete="off"
                           v-decorator="['interviewer',{rules: [{ required: true, message: 'نام مصاحبه کننده را وارد نمایید' }]}]"/>
                  </a-form-item>
                </div>
              </a-card>
              <br/>
              <a-card title="دانش تخصصی" :bordered="true">

                <a-form-item label="نمره">
                  <a-input-number v-decorator="['result_1.score',{initialValue: 0}]" :min="0" :max="20"/>
                </a-form-item>

                <a-form-item label="توضیحات">
                      <textarea class="ant-input"
                                placeholder=""
                                v-decorator="['result_1.desc']"
                                :auto-size="{ minRows: 2, maxRows: 6 }"
                      />
                </a-form-item>
              </a-card>
              <br/>
              <a-card title="تحصیلات مرتبط" :bordered="true">

                <a-form-item label="نمره">
                  <a-input-number v-decorator="['result_2.score',{initialValue: 0}]" :min="0" :max="20"/>
                </a-form-item>

                <a-form-item label="توضیحات">
                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_2.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />
                </a-form-item>
              </a-card>
              <br/>
              <a-card title="تجربه کاری مرتبط" :bordered="true">

                <a-form-item label="نمره">
                  <a-input-number v-decorator="['result_3.score',{initialValue: 0}]" :min="0" :max="20"/>
                </a-form-item>

                <a-form-item label="توضیحات">

                                        <textarea
                                            class="ant-input"
                                            placeholder=""
                                            v-decorator="['result_3.desc']"
                                            :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />

                </a-form-item>

                <!--  <a-form-item label="نتیجه">
                      <a-radio-group v-decorator="['result_3.sts']">
                          <a-radio :value="-1">
                              رد شده
                          </a-radio>
                          <a-radio :value="1">
                              قبول
                          </a-radio>

                      </a-radio-group>
                  </a-form-item>-->

              </a-card>
              <br/>
              <a-card title="رفتار و شخصیت عمومی" :bordered="true">

                <a-form-item label="نمره">
                  <a-input-number v-decorator="['result_4.score',{initialValue: 0}]" :min="0" :max="20"/>
                </a-form-item>

                <a-form-item label="توضیحات">

                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_4.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />

                </a-form-item>
                <!--
                                                    <a-form-item label="نتیجه">
                                                        <a-radio-group v-decorator="['result_4.sts']">
                                                            <a-radio :value="-1">
                                                                رد شده
                                                            </a-radio>
                                                            <a-radio :value="1">
                                                                قبول
                                                            </a-radio>

                                                        </a-radio-group>
                                                    </a-form-item>-->

              </a-card>
              <br/>
              <a-card title="ویژگی های اختصاصی شغل" :bordered="true">

                <a-form-item label="نمره">
                  <a-input-number v-decorator="['result_5.score',{initialValue: 0}]" :min="0" :max="20"/>
                </a-form-item>

                <a-form-item label="توضیحات">

                                        <textarea class="ant-input"
                                                  placeholder=""
                                                  v-decorator="['result_5.desc']"
                                                  :auto-size="{ minRows: 2, maxRows: 6 }"
                                        />

                </a-form-item>
              </a-card>
              <a-form-item label="نتیجه کلی مصاحبه">
                <a-radio-group
                    v-decorator="['sts',{rules: [{ required: true, message: 'نتیجه مصاحبه را انتخاب نمایید' }]}]">
                  <a-radio :value="-1">
                    رد شده
                  </a-radio>
                  <a-radio :value="1">
                    قبول
                  </a-radio>
                  <a-radio :value="2">
                    الویت دوم
                  </a-radio>
                </a-radio-group>
              </a-form-item>

            </a-form>

          </div>

        </div>

      </a-modal>
      <a-modal force-render v-model="setEmployeModel" :closable="false" ok-text="بله" cancel-text="خیر" @ok="setEmploye">
        <template #title>
          <div class="flex justify-between">
            <a-icon type="alert-circle" style="color:#faad14"/>
            <div>
               آیا مطمئن به استخدام هستید ؟
            </div>
          </div>
        </template>

        <a-spin type="loading" :spinning="loading">
          <div>در صورتی که گزینه تایید را انتخاب نمایید فرد مورد نظر به عنوان پرسنل در سیستم ثبت می شود</div>
          <a-form :form="fromPersonel">
            <a-form-item label="نمایش برای نوع کاربری">
              <a-select v-decorator="['user_type',{ rules:[{ required: true, message: 'نوع کاربری را وارد نمایید' }] }]" style="width: 120px">
                <a-select-option v-for="item in userTypes" :value="item.id">
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="id" class="hidden">
              <a-input v-decorator="['id',{ rules:[{ required: true, message: 'نوع کاربری را وارد نمایید' }] }]" />
            </a-form-item>
          </a-form>
        </a-spin>

      </a-modal>
      <a-modal force-render v-model="updateType" :closable="false" ok-text="بله" cancel-text="خیر" @ok="updateTypeProposal">
        <template #title>
          <div class="flex justify-between">
            <a-icon type="alert-circle" style="color:#faad14"/>
            <div>
               آیا مطمئن به ویرایش هستید ؟
            </div>
          </div>
        </template>

        <a-spin type="loading" :spinning="loading">
          <div>در صورتی که گزینه تایید را انتخاب نمایید فرد مورد نظر به عنوان پرسنل در سیستم ثبت می شود</div>
          <a-form :form="fromPersonel">
            <a-form-item label="نمایش برای نوع کاربری">
              <a-select v-decorator="['user_type',{ rules:[{ required: true, message: 'نوع کاربری را وارد نمایید' }] }]" style="width: 120px">
                <a-select-option v-for="item in userTypes" :value="item.id">
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="id" class="hidden">
              <a-input v-decorator="['id',{ rules:[{ required: true, message: 'نوع کاربری را وارد نمایید' }] }]" />
            </a-form-item>
          </a-form>
        </a-spin>

      </a-modal>
      <!--            <a-modal :width="800" v-model="editInformationModal" title="ویرایش درخواست" :forceRender="true">
                    <template slot="footer">
                      <a-button key="back" @click="editInformationModal=false">
                          بستن
                      </a-button>
                    </template>
                    <a-card title="اطلاعات فردی">
                      <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
                        <a-form-item label="نام و نام خانوادگی">
                          <input class="ant-input"  autocomplete="off" v-decorator="['name']"/>
                        </a-form-item>
                        <a-form-item label="شهر متقاضی شغل">
                          <input class="ant-input"  autocomplete="off" v-decorator="['for_cities']"/>
                        </a-form-item>
                        <a-form-item label="شغل متقاضی">
                          <input class="ant-input"  autocomplete="off" v-decorator="['job_title']"/>
                        </a-form-item>
                        <a-form-item label="نام پدر">
                          <input class="ant-input"  autocomplete="off" v-decorator="['father_name']"/>
                        </a-form-item>
                        <a-form-item label="تاریخ تولد">
                          <input class="ant-input"  autocomplete="off" v-decorator="['birth_date']"/>
                        </a-form-item>
                        <a-form-item label="کدملی">
                          <input class="ant-input"  autocomplete="off" v-decorator="['ncode']"/>
                        </a-form-item>
                        <a-form-item label="جنسیت">
                          <a-radio-group v-decorator="['gender']">
                            <a-radio :value="1">
                              مرد
                            </a-radio>
                            <a-radio :value="2">
                              زن
                            </a-radio>
                          </a-radio-group>
                        </a-form-item>
                        <a-form-item label="وضعیت تاهل">
                          <a-radio-group v-decorator="['marriage_sts']">
                            <a-radio :value="2">
                              متاهل
                            </a-radio>
                            <a-radio :value="1">
                              مجرد
                            </a-radio>
                          </a-radio-group>
                        </a-form-item>
                        <a-form-item label="شماره حساب بانک پاسارگاد">
                          <input class="ant-input"
                                 v-decorator="['pasargad_bank_number']"/>
                        </a-form-item>
                        <a-form-item label="حقوق درخواستی">
                          <input class="ant-input"  autocomplete="off" v-decorator="['requested_salary']"/>
                        </a-form-item>
                        <a-form-item label="شماره شناسنامه">
                          <input class="ant-input"  autocomplete="off" v-decorator="['iden_id']"/>
                        </a-form-item>
                        <a-form-item label="سریال شناسنامه">
                          <input class="ant-input"  autocomplete="off" v-decorator="['iden_serial']"/>
                        </a-form-item>
                        <a-form-item label="محل صدور">
                          <input class="ant-input"  autocomplete="off" v-decorator="['iden_place']"/>
                        </a-form-item>
                        <a-form-item label="محل تولد">
                          <input class="ant-input"  autocomplete="off" v-decorator="['birth_place']"/>
                        </a-form-item>
                        <a-form-item label="وضعیت مسکن">
                          <a-radio-group v-decorator="['house_sts']">
                            <a-radio :value="1">
                              مالک
                            </a-radio>
                            <a-radio :value="2">
                              مستاجر
                            </a-radio>
                          </a-radio-group>
                        </a-form-item>
                        <a-form-item label="آدرس" class="col-span-3" >
                          <input  class="ant-input"  autocomplete="off" v-decorator="['address',{initialValue: null,rules: [{ required: false, message: 'آدرس را وارد نمایید' }]}]" />
                        </a-form-item>
                        <a-form-item label="ایمیل">
                          <input class="ant-input"  autocomplete="off" v-decorator="['email']"/>
                        </a-form-item>
                        <a-form-item label="موبایل">
                          <input class="ant-input"  autocomplete="off" v-decorator="['mobile']"/>
                        </a-form-item>
                        <a-form-item label="تلفن ثابت">
                          <input class="ant-input"  autocomplete="off" v-decorator="['phone']"/>
                        </a-form-item>
                        <a-form-item label="تلفن ضروری">
                          <input  class="ant-input"  style="direction: rtl !important;" v-decorator="['phone_emergency',{initialValue: null,rules: [{ required:false, message: 'تلفن ضروری را وارد نمایید' }]}]">
                        </a-form-item>
                        <a-form-item label="نام فرد">
                          <input  class="ant-input"  autocomplete="off" v-decorator="['phone_emergency_name',{initialValue: null}]" >
                        </a-form-item>
                        <a-form-item label="نسبت">
                          <input  class="ant-input"  autocomplete="off" v-decorator="['phone_emergency_related',{initialValue: null}]" >
                        </a-form-item>
                        <a-form-item label="وضعیت بیمه">
                          <a-radio-group v-decorator="['has_insurance']">
                            <a-radio :value="-1">
                              ندارد
                            </a-radio>
                            <a-radio :value="1">
                              دارد
                            </a-radio>
                          </a-radio-group>
                        </a-form-item>
                        <a-form-item label="شماره بیمه">
                          <input class="ant-input"
                                 v-decorator="['insurance_no']"/>
                        </a-form-item>
                        <a-form-item label="تعداد فرزند">
                          <input class="ant-input" v-decorator="['count_child',{rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{ pattern: /^[0-9]+$/, message: 'فقط عدد مجاز است' }] }]"/>
                        </a-form-item>
                        <a-form-item label="وضعیت نظام وظیفه">
                          <a-select  style="width: 100%" v-decorator="['military_sts',{rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' }] }]">
                            <a-select-option v-for="(item,index) in {1:'معاف',2:'مشمول',3:'پایان خدمت',}" :value="index">
                              {{ item }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </div>
                    </a-card>
                    <a-card title="اطلاعات خانوادگی" class="mt-5">
                      <a slot="extra" @click.prevent="AddFamily()" :disabled="!$getAccess('contract.basic.family.create')">افزودن اطلاعات خانوادگی</a>
                      <template v-for="(item,index) in personalDetails['family']" >
                        <a-button :disabled="!$getAccess('contract.basic.family.delete')" type="danger" @click="handleRemoveFamily(item,index)">حذف</a-button>
                        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
                          <a-form-item style="display: none">
                            <input type="hidden" class="ant-input" autocomplete="off" v-decorator="[`personal_details.family[${index}].id`]"/>
                          </a-form-item>
                          <a-form-item label="نام">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.family[${index}].name`]"/>
                          </a-form-item>
                          <a-form-item label="نسبت">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.family[${index}].relation`]"/>
                          </a-form-item>
                          <a-form-item label="مقطع">
                            &lt;!&ndash; <a-input autocomplete="off" v-decorator="['personal_details[0].university',{rules: [{ required: true, message: 'وارد کردن شغل الزامی است' }]}]"/>&ndash;&gt;
                            <a-select v-decorator="[`personal_details.family[${index}].edu_level`]" >
                              <a-select-option :value="1">
                                کاردانی
                              </a-select-option>
                              <a-select-option :value="2">
                                کارشناسی
                              </a-select-option>
                              <a-select-option :value="3" >
                                کارشناسی ارشد
                              </a-select-option>
                              <a-select-option :value="4">
                                دکترا
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                          &lt;!&ndash;  <a-form-item label="دانشگاه">
                              <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.family[${index}].university`]"/>
                            </a-form-item>&ndash;&gt;
                          <a-form-item label="رشته تحصیلی">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.family[${index}].edu_title`]"/>
                          </a-form-item>
                          <a-form-item label="شغل">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.family[${index}].job`]"/>
                          </a-form-item>
                        </div>
                        <a-divider />
                      </template>
                    </a-card>

                    <a-card title="اطلاعات تحصیلی" class="mt-5">
                      <a :disabled="!$getAccess('contract.basic.education.create')" slot="extra" @click.prevent="AddEducation()">افزودن سابقه تحصیلی</a>
                      <template v-for="(item,index) in personalDetails['education']">
                        <a-button :disabled="!$getAccess('contract.basic.education.delete')" type="danger" @click="handleRemoveEducation(item,index)">حذف</a-button>
                        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
                          <a-form-item style="display: none">
                            <input type="hidden" class="ant-input" autocomplete="off" v-decorator="[`personal_details.education[${index}].id`]"/>
                          </a-form-item>
                          <a-form-item label="مقطع">
                            &lt;!&ndash; <a-input autocomplete="off" v-decorator="['personal_details[0].university',{rules: [{ required: true, message: 'وارد کردن شغل الزامی است' }]}]"/>&ndash;&gt;
                            <a-select v-decorator="[`personal_details.education[${index}].level`]" >
                              <a-select-option :value="1">
                                کاردانی
                              </a-select-option>
                              <a-select-option :value="2">
                                کارشناسی
                              </a-select-option>
                              <a-select-option :value="3" >
                                کارشناسی ارشد
                              </a-select-option>
                              <a-select-option :value="4">
                                دکترا
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                          <a-form-item label="دانشگاه">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.education[${index}].university`]"/>
                          </a-form-item>
                          <a-form-item label="رشته تحصیلی">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.education[${index}].title`]"/>
                          </a-form-item>
                          <a-form-item label="گرایش">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.education[${index}].trend`]"/>
                          </a-form-item>
                          <a-form-item label="سال شروع">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.education[${index}].start_at`]"/>
                          </a-form-item>
                          <a-form-item label="سال خاتمه">
                            <input class="ant-input"  autocomplete="off" v-decorator="[`personal_details.education[${index}].end_at`]"/>
                          </a-form-item>
                        </div>
                        <a-divider />
                      </template>
                    </a-card>

                    <a-card title="سوابق آموزشی" class="mt-5">
                      <a :disabled="!$getAccess('contract.basic.train.create')" slot="extra" @click.prevent="AddTraning()">افزودن سابقه آموزشی </a>
                      <template v-for="(item,index) in personalDetails['traning']">
                        <a-button :disabled="!$getAccess('contract.basic.train.delete')" type="danger" @click="handleRemoveTraning(item,index)">حذف</a-button>
                        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
                          <a-form-item style="display: none">
                            <input type="hidden" class="ant-input" autocomplete="off" v-decorator="[`personal_details.traning[${index}].id`]"/>
                          </a-form-item>
                          <a-form-item label="مرکز برگزاری">
                            <input class="ant-input"   autocomplete="off" v-decorator="[`personal_details.traning[${index}].university`]"/>
                          </a-form-item>
                          <a-form-item label="عنوان دوره ">
                            <input class="ant-input"   autocomplete="off" v-decorator="[`personal_details.traning[${index}].title`]"/>
                          </a-form-item>
                          <a-form-item label="سال">
                            <input class="ant-input"   autocomplete="off" v-decorator="[`personal_details.traning[${index}].start_at`]"/>
                          </a-form-item>
                          <a-form-item label="امکان ارائه گواهینامه دارم">
                            <a-checkbox v-decorator="[`personal_details.traning[${index}].has_certificate`,{initialValue:false,valuePropName: 'checked'}]"/>
                          </a-form-item>
                        </div>
                        <a-divider />
                      </template>
                    </a-card>

                    <a-card title="سوابق کاری" class="mt-5">
                      <a :disabled="!$getAccess('contract.basic.job.create')" slot="extra" @click.prevent="AddJobsHistory()">افزودن سابقه کاری</a>
                      <template v-for="(item,index) in personalDetails['jobs_history']">
                        <a-button :disabled="!$getAccess('contract.basic.job.delete')" type="danger" @click="handleRemoveJobsHistory(item,index)">حذف</a-button>
                        <div class="grid sm:grid-cols-1 md:grid-cols-3 md:gap-3 lg:grid-cols-3 lg:gap-3">
                          <a-form-item style="display: none">
                            <input type="hidden" class="ant-input" autocomplete="off" v-decorator="[`personal_details.jobs_history[${index}].id`]"/>
                          </a-form-item>
                          <a-form-item label="نام سازمان ">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.jobs_history[${index}].university`]"/>
                          </a-form-item>
                          <a-form-item label="عنوان شغل">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.jobs_history[${index}].title`]"/>
                          </a-form-item>
                          <a-form-item label="دلیل خاتمه">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.jobs_history[${index}].note`]"/>
                          </a-form-item>

                          <a-form-item label="سال شروع">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.jobs_history[${index}].start_at`]"/>
                          </a-form-item>
                          <a-form-item label="سال خاتمه">
                            <input class="ant-input" autocomplete="off" v-decorator="[`personal_details.jobs_history[${index}].end_at`]"/>
                          </a-form-item>
                          &lt;!&ndash;<a-form-item label="تاکنون">
                            <a-checkbox v-decorator="['end_now',{initialValue:false,valuePropName: 'checked'}]" />
                          </a-form-item>&ndash;&gt;
                        </div>
                        <a-divider />
                      </template>
                    </a-card>

                    <a-card title="سوابق شخصی" class="mt-5">

                      <div class="dropbox">
                        <a-upload-dragger
                            :multiple="false"
                            action="http://hr.asco-intl.com/back/public/api/register/upload"
                            :file-list="prsonalFileList"
                            :default-file-list="prsonalFileList"
                            @change="fileUpload"
                            :remove="fileRemove"
                        >
                          <p class="ant-upload-drag-icon">
                            <a-icon type="inbox" />
                          </p>
                          <p class="ant-upload-text">
                            فایل را درگ کنید یا اینکه کاوش کنید.
                          </p>
                          <p class="ant-upload-hint">
                            فایلی که بارگذاری می کنید باید زیر ۵ مگابایت باشد.
                          </p>
                        </a-upload-dragger>
                      </div>

                    </a-card>
                  </a-modal>-->
    </a-card>
  </a-spin>
</template>

<script>
import * as  TableCol from './proposalTbl';
import XTable from "@/components/new-x-table/XTable";
import axios from "@/axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {printWindow, setKeyEvent, removeKeyEvent} from "@/mixin/keyEvent";

export default {
  components: {
    XTable,
    datePicker: VuePersianDatetimePicker
  },
  data() {
    return {
      prsonalFileList: [],
      file_ids: [],
      showMosahebeModal: false,
      showInformationModal: false,
      showAddMosahebeModal: false,
      personalInformation: {},
      personalDetails: {},
      cols: null,
      current: 0,
      fromMosahebe: this.$form.createForm(this, {name: 'coordinated'}),
      mosahebe: null,
      interview_at: null,
      row_id: null,
      interview: [],
      title_interview: ['دانش تخصصی', 'تحصیلات مرتبط', 'تجربه کاری مرتبط', 'رفتار و شخصیت عمومی', 'ویژگی های اختصاصی شغل'],
      is_skeleton: false,

      // requestEditMode:false,
      editInterviewModel: false,
      editingInterviewIndex: undefined,
      mosahebeData: {},
      fromMosahebe0: this.$form.createForm(this, {name: 'coordinated'}),
      fromMosahebe1: this.$form.createForm(this, {name: 'coordinated'}),
      fromMosahebe2: this.$form.createForm(this, {name: 'coordinated'}),
      fromPersonel: this.$form.createForm(this, {name: 'coordinated'}),
      setEmployeModel: false,
      updateType: false,
      loading: false,
      userTypes: [],
    }
  },
  computed: {
    admin(){
      return JSON.parse(localStorage.userInfo).name
    }
  },
  methods: {
    editInterview(e) {
      e.preventDefault();
      this.fromMosahebe.validateFields(async (err, values) => {
        try {
          if (!err) {
            this.$vs.loading()
            console.log(values, 'values')
            values.interview_at = this.interview_at
            await axios.put(`/proposal/interview/update/${this.editingInterviewIndex}`, values)
            this.editInterviewModel = false
            this.$ntSet('اطلاعات با موفقیت کامل شد')
            this.fromMosahebe.resetFields();
          } else {
            this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
          }
        } catch (e) {
          this.$ntSetError()
          throw e
        } finally {
          this.$vs.loading.close()
        }
      });
    },
    openEditInterviewModal(item) {
      item.result.map((i, index) => {
        item[`result_${index + 1}`] = {
          desc: i.desc,
          score: i.score
        }
      })
      this.editingInterviewIndex = item.id
      this.showMosahebeModal = false
      this.editInterviewModel = true
      this.interview_at = item.interview_at
      this.fromMosahebe.setFieldsValue(item)
    },
    fileUpload({fileList, event, file}) {
      if (file.response && file.response.id) {
        this.file_ids = fileList.map(x => x.id || x.response.id)
      }
      this.prsonalFileList = fileList;
      /*if (file.response && file.response.id) {
        this.file_id = file.response.id;
      }
      this.prsonalFileList = fileList;*/
    },
    showAddMosahebe(id) {
      this.showAddMosahebeModal = true;
      this.row_id = id
    },
    showMosahebe(id) {
      this.showMosahebeModal = true;
      this.getInterView(id)
    },

    async getInterView(id) {
      try {
        this.is_skeleton = true
        const {data} = await axios.post('proposal/interview', {id: id})
        this.interview = data
      } catch (e) {
        this.$ntSetError()
      } finally {
        this.is_skeleton = false
      }
    },

    savefromMosahebe(e) {
      try {
        if (this.current < 2) {
          this.next(e);
        } else {
          this[`fromMosahebe${this.current}`].validateFields(async (err, values) => {
            if (!err) {
              console.log(values, 'values')
              const id = this.row_id
              values.interview_at = this.interview_at
              values.id = id
              this.mosahebeData = Object.assign(this.mosahebeData, values)
              await axios.post('proposal/update', this.mosahebeData)
              this.showAddMosahebeModal = false
              this.mosahebeData = {}
              this.current = 0;
              //this.fromMosahebe.resetFields();
              this.$ntSet('اطلاعات با موفقیت کامل شد')
              this.fromMosahebe.resetFields();
            } else {
              this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
            }
          })
        }
      } catch (e) {
        this.$ntSetError()
        throw e
      } finally {
      }
    },
    /* interview(e) {
         e.preventDefault();
         this.fromMosahebe.validateFields(async (err, values) => {
             if (!err) {

                 if(this.current<2)
                 {
                     this.next();
                 }
                 else
                 {

                 }
             }
         });
     },*/
    next(e) {
      e.preventDefault();
      this[`fromMosahebe${this.current}`].validateFields(async (err, values) => {
        if (!err) {
          this.mosahebeData = Object.assign(this.mosahebeData, values)
          this.current++;
        } else {
          this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
        }
      })
    },
    prev() {
      this.current--;
    },
    async showDetails(record) {
      console.clear()
      console.log(record)
      if (record.file_ids) {
        this.file_ids = record.file_ids
        this.prsonalFileList =  record.file_list.map(x => {
          return {
            uid: x.id,
            id: x.id,
            name: x.filename,
            status: 'done',
            url: x.storage
          }
        })
      }
      try {
        this.loading = true
        const {data} = await axios.post('/proposal/details', {id: record.id})
        this.personalInformation = record
        this.personalDetails = data
        this.showInformationModal = true
      }
      catch (e) {
        this.$message.error('خطا در دریافت اطلاعات');
      }
      finally {
        this.loading = false
      }
    },
    async printDetails(record) {
      await this.showDetails(record)
      this.showInformationModal = false
      printWindow()
    },
    async deleteProposal(id) {
      try {
        this.is_skeleton = true
        await axios.get(`proposal/delete/${id}`)
        this.$refs.proposalTbl.fetch()
        this.$ntSet()
      } catch (e) {
        this.$ntSetError()
      } finally {
        this.is_skeleton = false
      }
    },
    async updateTypeProposal(e) {
      e.preventDefault();
      this.fromPersonel.validateFields(async (err, values) => {
        try {
          if (!err) {
            this.loading = true
            await axios.get(`personnel/update/type/${values.id}/${values.user_type}`)
            this.setEmployeModel = false
            this.$refs.proposalTbl.fetch()
            this.$ntSet()
          }
          else{
              this.$message.error('انتخاب نوع کاربر الزامی است')
          }
        } catch ({message}) {
          this.$message.error('این کاربر قبلا استخدام شده است.')
        } finally {
          this.loading = false
        }
      })
    },
    showSetEmployeModal(id) {
      this.setEmployeModel = true
      this.fromPersonel.setFieldsValue({
        id
      })
    },
    showUpdateTypeModal(id) {
      this.updateType = true
      this.fromPersonel.setFieldsValue({
        id
      })
    },
    async setEmploye(e) {
      e.preventDefault();
      this.fromPersonel.validateFields(async (err, values) => {
        try {
          if (!err) {
            this.loading = true
            await axios.post(`proposal/set-personnel`, values)
            this.setEmployeModel = false
            this.$message.success('اطلاعات با موفقیت ثبت شد.');
          }
          else{
              this.$message.error('انتخاب نوع کاربر الزامی است')
          }
        } catch ({message}) {
          this.$message.error('این کاربر قبلا استخدام شده است.')
        } finally {
          this.loading = false
        }
      })
    },
    async getUserTypes(){
        try{
          this.loading = true
          const {data} = await axios.get('/permission/type')
          this.userTypes = Object.values(data)
        }catch (e) {
          console.log("errr:",e)
        }finally {
          this.loading = false
        }
      },

  },
  watch: {
    showInformationModal(val){
      if (val) this.$store.commit('SetViewData', true)
      else this.$store.commit('SetViewData', false)
    }
  },
  async created() {
    this.cols = TableCol.default;
    await this.getUserTypes()

    setKeyEvent()
  },
  beforeDestroy() {
    removeKeyEvent()
  }
}
</script>

<style>
/*.ant-modal-mask {
  z-index: 9999999 !important;
}

.ant-modal-wrap {
  z-index: 999999999 !important;
}*/

ant-modal-title {
  margin-right: 1rem;
}

.ant-steps-item-title::after {
  /*left: unset !important;*/
  right: 100% !important;
}

/*.ant-modal-close
{
  left: 0 !important;
}*/

</style>
